import { Music, MusicIcon, Volume2, VolumeX, Play, Pause } from "lucide-react";
import { useSound } from "@/lib/sound";
import { useT } from "@/lib/i18n";

export default function SoundControls({ variant = "dark" }) {
    const { soundOn, setSoundOn, musicOn, setMusicOn } = useSound();
    const { t } = useT();
    const dark = variant === "dark";
    const base = dark
        ? "border-white/25 bg-white/10 hover:bg-white/20 text-white"
        : "border-black/10 bg-white hover:bg-bg-alt text-ink-primary";

    return (
        <div className="inline-flex items-center gap-2" data-testid="sound-controls">
            <button
                type="button"
                data-testid="toggle-click-sound"
                title={soundOn ? t("common.soundOn") : t("common.soundOff")}
                aria-label={soundOn ? t("common.soundOn") : t("common.soundOff")}
                onClick={() => setSoundOn(!soundOn)}
                className={`inline-flex items-center justify-center w-9 h-9 rounded-full border ${base} transition-colors`}
            >
                {soundOn ? <Volume2 size={15} strokeWidth={1.6} /> : <VolumeX size={15} strokeWidth={1.6} />}
            </button>
            <button
                type="button"
                data-testid="toggle-music"
                title={musicOn ? t("common.musicOn") : t("common.musicOff")}
                aria-label={musicOn ? t("common.musicOn") : t("common.musicOff")}
                onClick={() => setMusicOn(!musicOn)}
                className={`inline-flex items-center justify-center w-9 h-9 rounded-full border ${base} transition-colors ${
                    musicOn ? "ring-2 ring-emerald-400/40" : ""
                }`}
            >
                {musicOn ? <Pause size={15} strokeWidth={1.6} /> : <Music size={15} strokeWidth={1.6} />}
            </button>
        </div>
    );
}
